import _difference from 'lodash/difference';
import _isObject from 'lodash/isObject';

const $userCanEditNews = {
  methods: {
    /**
     * Un utente può modificare una news se è admin, oppure se l'utente ha un numero maggiore o uguale ai tenant della news e la news non è bloccata nell'editing (e l'utente collegato non è l'autore)
     */
    $userCanEditNews(user, news) {
      try {
        let newsFederation = [];
        // Tenants can either be an array of objects or simply id
        if (_isObject(news.federation[0])) {
          newsFederation = news.federation.map((tenant) => tenant._id);
        } else {
          newsFederation = news.federation;
        }
        return (
          this.$userHasRoles(['admin']) ||
          (!_difference(newsFederation, user.tenants).length &&
            (user.targets && user.targets.length
              ? !_difference(news.target, user.targets).length
              : true) &&
            (this.news.locked ? this.$user.email === this.news.cuser_email : true))
        );
      } catch (err) {
        console.log('userCanEditNews mixin error', err);
        return false;
      }
    },
  },
};

export { $userCanEditNews };
